import { render, staticRenderFns } from "./subagent_badge.vue?vue&type=template&id=5e1808e5"
import script from "./subagent_badge.vue?vue&type=script&lang=js"
export * from "./subagent_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports